// 混合拆单跨页文案与纯格式化工具：我的訂單提醒、續建對話框、兩單結果页与下单页共用，
// 放在 order-shared 以免品牌复制根外的组件反向依赖 order-create。规则见 docs/ai/order-mixed-split.md。

export function getParcelDisplayName (parcel) {
  const extraInfo = parcel?.extraInfo || {}
  const nameItem = (extraInfo.nameList || []).find(item => item?.itemTwName)
  return nameItem?.itemTwName || extraInfo.tpttName || parcel?.trackingNo || ''
}

export function formatTwd (amount) {
  const value = Math.round(Number(amount) || 0)
  return value.toLocaleString('en-US')
}

// 文案件数规则：≤2 件列品名，≥3 件一律「N 件」。
export function formatParcelNames (parcels = [], { maxNames = 2 } = {}) {
  const list = Array.isArray(parcels) ? parcels : []
  if (!list.length) return ''
  if (list.length <= maxNames) return list.map(getParcelDisplayName).join('、')
  return `${list.length} 件`
}

export function joinParcelNames (parcels = []) {
  return parcels.map(getParcelDisplayName).join('、')
}

export function buildSplitSecondBannerText (record) {
  if (!record) return ''
  const count = Number(record.firstCount) || 0
  const amount = record.firstAmount == null ? '' : `，${formatTwd(record.firstAmount)} 元`
  return `第一單（海運 ${count} 件${amount}）已建立。以下為第二單，請確認後送出。`
}

export function buildSplitContinueText (record) {
  if (!record) return ''
  const names = (record.parcelNames || []).slice(0, 2).join('、')
  const count = (record.pclids || []).length
  const label = count > 2 ? `${count} 件` : names
  const estimate = record.estimateTotal == null ? '' : `${formatTwd(record.estimateTotal)} 元，`
  return `海快 ${count} 件（${label}）${estimate}需另外付款。`
}

export function buildSplitPendingText (record) {
  if (!record) return ''
  const count = (record.pclids || []).length
  const names = (record.parcelNames || []).slice(0, 2).join('、')
  const label = count > 2 ? `${count} 件包裹` : names
  return `${label}尚未建立第二單，目前不在任何訂單中。`
}

// 兩單結果页状态：以第二单是否付款为准（第一单可能已取消／退款），两单都付款才是「兩單付款成功」。
export function resolveSplitResultView ({ firstOrder, secondOrder } = {}) {
  const firstPaid = String(firstOrder?.jyoPayStatus) === '9'
  const secondPaid = String(secondOrder?.jyoPayStatus) === '9'
  const firstVoid = ['0', '2'].includes(String(firstOrder?.jyoPayStatus))
  const bothPaid = firstPaid && secondPaid
  let title = '第二單尚未付款'
  let note = ''
  if (bothPaid) {
    title = '兩單付款成功'
    note = '兩單分開寄出、到貨時間不同；可在「我的訂單」查看進度。'
  } else if (secondPaid) {
    title = '第二單付款成功'
    note = `第一單${firstVoid ? '已取消' : '尚未付款'}，兩單分開處理；可在「我的訂單」查看進度。`
  }
  return { firstPaid, secondPaid, firstVoid, bothPaid, done: secondPaid, title, note }
}
